export const staticDictionary = {
  userGradeList: [
    {name: '一年级', id: 1},
    {name: '二年级', id: 2},
    {name: '三年级', id: 3},
    {name: '四年级', id: 4},
    {name: '五年级', id: 5},
    {name: '六年级', id: 6},
    {name: '七年级', id: 7},
    {name: '八年级', id: 8},
    {name: '九年级', id: 9},
    {name: '高一', id: 10},
    {name: '高二', id: 11},
    {name: '高三', id: 12},
  ],
};
